export const maxOutgoingEmergencyContacts = 5;
export const maxOutgoingRecoveryContacts = 5;
